import * as React from "react";
import TextField from "@mui/material/TextField";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import dayjs from "dayjs";
const Datetimepicker = (props: any) => {
  const { data, change, node } = props;
  const handleChange = (nodess: any) => {
    // console.log("nodessnodessnodessnodess",nodess)
    let updateData = [...data];
    let filter;
    filter = updateData.filter((n) => {
      return n.name === node.name;
    });
    // debugger
    if (filter[0] && nodess && nodess.$d !== "Invalid date") {
      filter[0].value = moment(nodess?.$d).format("YYYY-MM-DD HH:mm:ss");
    } else if (nodess === null) {
      filter[0].value = "";
    }
    // console.log("searchResult",updateData)
    change([...updateData]);
  };
  const onkeydown = (e: any) => {
    e.preventDefault();
  };
  const checkMaxMinDate = (direction: "min" | "max") => {
    const operator = node?.reference?.condition?.operator;
    const maxRangeMonths = node?.reference?.maxRangeMonths;

    let refFilter: any = null;
    if (node?.reference?.items) {
      refFilter = data.find((n: any) => n.name === node.reference.items);
    }
    const refValue = refFilter?.value ? dayjs(refFilter.value) : null;

    if (direction === "min") {
      if (operator === ">") {
        return refValue && refValue.isValid() ? refValue : null;
      }
      if (operator === "<" && maxRangeMonths && refValue && refValue.isValid()) {
        return refValue.subtract(maxRangeMonths, "month");
      }
    }

    if (direction === "max") {
      if (operator === "<") {
        return refValue && refValue.isValid() ? refValue : null;
      }
      if (operator === ">") {
        if (maxRangeMonths && refValue && refValue.isValid()) {
          const rangeLimit = refValue.add(maxRangeMonths, "month");
          const today = dayjs();
          return rangeLimit.isBefore(today) ? rangeLimit : today;
        }
      }
    }

    return null;
  };
  return (
    <div id={`date_time_${node?.title}`} className="">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DateTimePicker
          disabled={node.disabled || false}
          className={`${node.disabled ? "bg-[#aaaaaa1d]" : ""}`}
          minDate={checkMaxMinDate("min")}
          maxDate={checkMaxMinDate("max") || dayjs()}
          renderInput={(params) => (
            <TextField
              {...params}
              onKeyDown={(e: any) => {
                onkeydown(e);
              }}
            />
          )}
          value={node?.value ? dayjs(node.value) : null}
          label={node?.title}
          onChange={handleChange}
        />
      </LocalizationProvider>
    </div>
  );
};

export default Datetimepicker;
